import { AnalyticsTypes } from '../../../middleware/google-analytics';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../../EventTrackingConstants';

const CHECK_INSURANCE_MODAL_KEY = '@@checkInsuranceModal';

const ActionTypes = {
    TRACK_SHOW_CHECK_INSURANCE_MODAL: `${CHECK_INSURANCE_MODAL_KEY}/TRACK_SHOW_CHECK_INSURANCE_MODAL`,
    TRACK_CLICK_CHECK_MY_INSURANCE: `${CHECK_INSURANCE_MODAL_KEY}/TRACK_CLICK_CHECK_MY_INSURANCE`,
    TRACK_CLICK_CLOSE_CHECK_INSURANCE_MODAL: `${CHECK_INSURANCE_MODAL_KEY}/TRACK_CLICK_CLOSE_CHECK_INSURANCE_MODAL`,
};

export const trackShowCheckInsuranceModal = () => ({
    type: ActionTypes.TRACK_SHOW_CHECK_INSURANCE_MODAL,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Show Check Insurance Modal',
            data: {
                Section: TARGETS.CHECK_INSURANCE_MODAL,
                Component: TARGETS.CHECK_INSURANCE_MODAL,
                InteractionType: INTERACTION_TYPES.VIEW,
                Initiator: EVENT_INITIATORS.USER,
                Element: TARGETS.CHECK_INSURANCE_MODAL,
                EventAction: 'show check insurance modal',
            },
        },
    },
});

export const trackClickCheckMyInsurance = () => ({
    type: ActionTypes.TRACK_CLICK_CHECK_MY_INSURANCE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Check My Insurance',
            data: {
                Section: TARGETS.CHECK_INSURANCE_MODAL,
                Component: TARGETS.CHECK_INSURANCE_MODAL,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                Element: TARGETS.CHECK_MY_INSURANCE_BUTTON,
                EventAction: 'click check my insurance',
            },
        },
    },
});

export const trackClickCloseCheckInsuranceModal = () => ({
    type: ActionTypes.TRACK_CLICK_CLOSE_CHECK_INSURANCE_MODAL,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Close Check Insurance Modal',
            data: {
                Section: TARGETS.CHECK_INSURANCE_MODAL,
                Component: TARGETS.CHECK_INSURANCE_MODAL,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                Element: TARGETS.CHECK_INSURANCE_MODAL_CLOSE_ICON,
                EventAction: 'click close check insurance modal',
            },
        },
    },
});
